const MOBILE_BREAKPOINTS = ['sm', 'xs', 'md'];

export const isMobile = {
  computed: {
    isMobile() {
      if (!this.$vuetify.breakpoint) {
        return false;
      }
      return MOBILE_BREAKPOINTS.includes(this.$vuetify.breakpoint.name);
    },
  },
};
